export function formatClock(seconds) {
    const total = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0))
    const hours = Math.floor(total / 3600)
    const minutes = Math.floor((total % 3600) / 60)
    const secs = String(total % 60).padStart(2, "0")

    return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${secs}` : `${minutes}:${secs}`
}
